(function($){
    'use strict';
    
    var $overlays = $('.overlay');

    if($overlays.length){
        $overlays.click(function () {
            var $popupControl = $(this),
                popupTitle = $popupControl.text().trim();
            var popupVideoId = matchYoutubeUrl($popupControl.attr('href'));
            var iframeSrc = '';

            if(!popupVideoId) {
                popupVideoId = matchVimeoUrl($popupControl.attr('href'));

                if(popupVideoId) {
                    //Vimeo
                    iframeSrc = 'https://player.vimeo.com/video/' + popupVideoId + '?rel=0&autoplay=1';
                }
            } else {
                //Youtube
                iframeSrc = 'https://www.youtube.com/embed/' + popupVideoId + '?rel=0&hd=1&autoplay=1';
            }

            console.log(popupTitle, popupVideoId);

            var html = '<div class="popup">\n' +
                            '<div class="popup__wrapper">\n' +
                                '<div class="popup__content">\n' +
                                    '<div class="popup__close">\n' +
                                        '<button><span class="sr-only">Close</span></button>\n' +
                                    '</div>\n' +
                                    '<div class="popup__video"><iframe width="560" height="349" src="' + iframeSrc + '" frameborder="0" allowfullscreen></iframe></div>\n' + 
                                '<div>\n' +
                                '<div class="popup__title">' + popupTitle + '<div>\n' +
                            '<div>\n' +
                        '<div>\n';

            $('body').append(html);

            var $popup = $('.popup'),
                $popupClose = $popup.find('button'),
                $popupContent = $popup.find('.popup__content');

            $popup.fadeIn(300).click(function() {
                $popup.remove();
                return false;
            });

            $popupClose.click(function() {
                $popup.remove();
                return false;
            });
            
            $popupContent.click(function() {
                return false;
            });

            return false;
        });
    } 

	function matchYoutubeUrl(url){
	    var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
	    return (url.match(p)) ? RegExp.$1 : false ;
    }
    
    function matchVimeoUrl(url){
	    var p = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
	    return (url.match(p)) ? RegExp.$1 : false ;
	}
}(jQuery));